import {Component, effect, Input, OnInit} from '@angular/core';
import {ProyectoPerfil} from "../../../../../interfaces/perfil.interface";
import {PersonasService} from "../../../../../../shared/services/personas-service";
import {DraftProjectService} from "../../../../services/draft-project.service";
import {TableModule} from "primeng/table";
import {Button} from "primeng/button";
import {TagModule} from "primeng/tag";
import {TooltipModule} from "primeng/tooltip";
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-personas-proyecto-table',
    standalone: true,
    templateUrl: './personas-proyecto-table.component.html',
    imports: [
        TableModule,
        Button,
        TagModule,
        TooltipModule,
        NgIf
    ],
    styleUrl: './personas-proyecto-table.component.scss'
})
export class PersonasProyectoTableComponent implements OnInit {
    constructor(public personasService: PersonasService, protected draftProjectService:DraftProjectService) {
        this.formularioCompleto = false;
    }
    @Input('personas') public personas: ProyectoPerfil[] = [];
    @Input('paso') public paso:number=0;
    @Input('formularioCompleto') public formularioCompleto: boolean = false;
    ngOnInit(): void {
    }

    eliminarPropietario(indice: number, pasoActual: number) {
        const personasFiltradas = this.filterPorPaso(this.draftProjectService.draftProject().tenenciaLegal!, pasoActual);
        const indiceEnListaCompleta = this.draftProjectService.draftProject().tenenciaLegal.findIndex(persona => persona === personasFiltradas[indice]);
        this.draftProjectService.draftProject.update(draft => ({
            ...draft, tenenciaLegal: draft.tenenciaLegal.filter((_, i) => i !== indiceEnListaCompleta)
        }));
        this.draftProjectService.existeTenencia.set(this.draftProjectService.draftProject().tenenciaLegal)

    }

    filterPorPaso(items: ProyectoPerfil[], pasoActual: number) {
        if (items.length == 0)
            return [];
        return items.filter(person => person.idPasoGeneralidades === pasoActual)
    }

    countTenenciaEffect = effect(() => {
        if (this.draftProjectService.existeTenencia().length > 0) {
            this.draftProjectService.countTenenciaByStep.set(this.filterPorPaso(this.draftProjectService.existeTenencia(), this.paso).length)
        }else{
            this.draftProjectService.countTenenciaByStep.set(0)
        }

    }, {allowSignalWrites: true});
}
